import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap,map } from 'rxjs/operators';
import { User, UserData } from '../@core/interfaces/common/users';

@Injectable()
export class MobileGuard implements CanActivate {
    constructor(private authService: NbAuthService, private usersService: UserData, private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> {
        let name: string = "";
        return this.usersService.getCurrentUser()
            .pipe(
                
            map((user) => {
                name = (user as any).firstName + (user as any).lastName;
               
                if (name == "MobileMobile")
                    this.router.navigate(['/pages/masters/physician']);
                return true;
            })
            );
        // return this.authService.isAuthenticated()
        //     .pipe(
        //         tap(authenticated => {
        //             if (!authenticated) {
        //                 this.router.navigate(['auth/login']);
        //             }
        //             else {
        //                 this.usersService.getCurrentUser().subscribe(user => {
        //                     name = user.firstName + user.lastName;
        //                     if (name == "MobileMobile")
        //                         this.router.navigate(['/pages/masters/physician']);
        //                 });

        //             }
        //         }),
        //     );

    }
}
